var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6397 0.000488281C24.2535 0.000488281 25.8385 11.0095 25.8385 11.0095L25.8667 22.4151H50.0924V25.8394H16.2447C16.2447 25.8394 0 23.9971 0 49.6116C0 75.2269 14.1788 74.3185 14.1788 74.3185H22.6406V62.432C22.6406 62.432 22.1844 48.2532 36.593 48.2532H60.6205C60.6205 48.2532 74.1199 48.4713 74.1199 35.2065V13.2739C74.1199 13.2739 76.1702 0.000488281 49.6397 0.000488281ZM36.2817 7.67056C36.8542 7.67004 37.4211 7.78242 37.9501 8.00125C38.4791 8.22009 38.9598 8.54109 39.3646 8.94589C39.7693 9.35068 40.0903 9.83133 40.3092 10.3603C40.528 10.8893 40.6404 11.4563 40.6399 12.0287C40.6404 12.6012 40.528 13.1681 40.3092 13.6971C40.0903 14.2261 39.7693 14.7068 39.3646 15.1116C38.9598 15.5164 38.4791 15.8374 37.9501 16.0562C37.4211 16.275 36.8542 16.3874 36.2817 16.3869C35.7092 16.3874 35.1423 16.275 34.6133 16.0562C34.0843 15.8374 33.6037 15.5164 33.1989 15.1116C32.7941 14.7068 32.4731 14.2261 32.2542 13.6971C32.0354 13.1681 31.923 12.6012 31.9235 12.0287C31.923 11.4563 32.0354 10.8893 32.2542 10.3603C32.4731 9.83133 32.7941 9.35068 33.1989 8.94589C33.6037 8.54109 34.0843 8.22009 34.6133 8.00125C35.1423 7.78242 35.7092 7.67004 36.2817 7.67056Z",
    fill: "url(#paint0_linear_755_15524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3607 99.4806C75.747 99.4806 74.1619 88.4715 74.1619 88.4715L74.1337 77.0663H49.9076V73.642H83.7553C83.7553 73.642 100 75.4843 100 49.869C100 24.254 85.8213 25.1624 85.8213 25.1624H77.3594V37.0486C77.3594 37.0486 77.8156 51.2273 63.407 51.2273H39.3795C39.3795 51.2273 25.8801 51.0092 25.8801 64.2745V86.2075C25.8801 86.2075 23.8302 99.4806 50.3603 99.4806H50.3607ZM63.7187 91.8112C63.1462 91.8118 62.5793 91.6994 62.0503 91.4806C61.5213 91.2617 61.0407 90.9407 60.6359 90.5359C60.2311 90.1311 59.9101 89.6505 59.6912 89.1215C59.4724 88.5925 59.36 88.0255 59.3605 87.4531C59.36 86.8806 59.4723 86.3136 59.6911 85.7845C59.9099 85.2555 60.2309 84.7748 60.6357 84.37C61.0405 83.9651 61.5212 83.6441 62.0502 83.4252C62.5792 83.2064 63.1462 83.094 63.7187 83.0945C64.2912 83.094 64.8581 83.2064 65.3871 83.4252C65.9161 83.644 66.3968 83.965 66.8015 84.3698C67.2063 84.7746 67.5273 85.2553 67.7462 85.7843C67.965 86.3133 68.0774 86.8802 68.0769 87.4527C68.0774 88.0251 67.965 88.5921 67.7462 89.1211C67.5273 89.6501 67.2063 90.1307 66.8015 90.5355C66.3968 90.9403 65.9161 91.2613 65.3871 91.4802C64.8581 91.699 64.2912 91.8114 63.7187 91.8109V91.8112Z",
    fill: "url(#paint1_linear_755_15524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_15524",
    x1: 9.60996,
    y1: 8.94811,
    x2: 59.1669,
    y2: 58.0107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_15524",
    x1: 40.0281,
    y1: 40.4532,
    x2: 93.2466,
    y2: 90.7623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.e6ad5323f21080c7b3dc395a8af95740.svg";
export { ForwardRef as ReactComponent };